"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarBounds;

function getCalendarBounds(minDate, maxDate) {
  var today = new Date();
  var minCalendarDate = minDate || new Date(today.getFullYear() - 100, 0, 1);
  var maxCalendarDate = maxDate || new Date(today.getFullYear() + 100, 11, 31);
  return {
    minCalendarDate: minCalendarDate,
    maxCalendarDate: maxCalendarDate
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Calendar/helpers/getCalendarBounds.js
// module id = PwPx
// module chunks = 0